import { render } from "./rolCard.vue?vue&type=template&id=55004f23"
import script from "./rolCard.vue?vue&type=script&lang=js"
export * from "./rolCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__